import {mainAPI, tripsAPI} from '../api';
import {ChatMessagesListResponse, UnreadMessagesBulkInfoResponseData} from '../types/chatMessage';

export const getHistory = (trip_id: number, page: string | null) => {
    let url;
    if (page) {
        url = page
    } else {
        url = `chat_messages/?trip_id=${trip_id}`
    }
    return mainAPI.get<ChatMessagesListResponse>(
        url,
    ).then(
        (res) => {
            return Promise.resolve(res.data);
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}

export function getUnreadMessagesBulkInfo(tripIds: Array<number>) {
    return mainAPI.get<Array<UnreadMessagesBulkInfoResponseData>>(
        `chat_messages/unread_messages_info_bulk/?trips=${tripIds.join(',')}`,
    ).then(
        (res) => {
            return Promise.resolve(res.data);
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}

export type SendMessageParams = {
    chatId: string
    text: string
    repliedTo: string | null
    isImportant: boolean
    files: File[]
}

export function send(data: SendMessageParams) {
    let bodyFormData = new FormData();
    bodyFormData.append('chat', data.chatId);
    bodyFormData.append('text', data.text);
    if (!!data.repliedTo) {
        bodyFormData.append('replied_to', data.repliedTo);
    }
    bodyFormData.append('important', '' + data.isImportant);
    if (data.files) {
        for (let x = 0; x < data.files.length; x++) {
            bodyFormData.append('files', data.files[x]);
        }
    }

    return mainAPI.post(
        `chat_messages/`,
        bodyFormData,
        {
            headers: {"Content-Type": "multipart/form-data"},
        }
    ).then(
        (res) => {
            return Promise.resolve(res.data);
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}

export function readMessage(pk: string): Promise<any> {
    return mainAPI.post<any>(
        `chat_messages/${pk}/read/`
    ).then(
        (res) => {
            return Promise.resolve();
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}

export function deleteMessage(pk: string): Promise<any> {
    return mainAPI.delete<any>(
        `chat_messages/${pk}/`
    ).then(
        (res) => {
            return Promise.resolve();
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}